import { render } from "./HeroListShowDetailNav.vue?vue&type=template&id=467aa84e"
import script from "./HeroListShowDetailNav.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__